<dgx-uib-cover-starting-date-info-dynamic title="{{ infoTitle }} start date">
  <p [innerHtml]="infoText"></p>
</dgx-uib-cover-starting-date-info-dynamic>
